import React from 'react';
import { useTranslation } from 'react-i18next';

interface LanguageSwitcherProps {
  size?: 'sm' | 'md';
}

// EN / 中 膠囊切換器：SiteHeader（桌面 nav＋手機兩處）與 Phase 4 角色後台頁內工具列共用。
// 選擇後寫入 localStorage(gs_lang) 持久化；i18n 偵測本身不寫入（見 src/i18n/index.ts）。
const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ size = 'md' }) => {
  const { i18n, t } = useTranslation();
  const current = i18n.language?.toLowerCase().startsWith('en') ? 'en' : 'zh-TW';

  const switchTo = (lng: 'zh-TW' | 'en') => {
    if (lng === current) return;
    i18n.changeLanguage(lng);
    try {
      localStorage.setItem('gs_lang', lng);
    } catch { /* ignore */ }
  };

  const seg = (active: boolean) =>
    `px-2.5 py-1 rounded-full font-bold leading-none transition-colors ${
      active
        ? 'bg-[#C2410C] text-white'
        : 'text-stone-600 dark:text-gray-300 hover:text-[#C2410C]'
    }`;

  return (
    <div
      role="group"
      aria-label={t('common:brand.switchLanguage')}
      className={`inline-flex items-center rounded-full border border-stone-300 dark:border-gray-600 bg-white dark:bg-gray-800 ${
        size === 'sm' ? 'text-[11px]' : 'text-xs'
      }`}
    >
      <button
        type="button"
        onClick={() => switchTo('en')}
        aria-pressed={current === 'en'}
        className={seg(current === 'en')}
      >
        EN
      </button>
      <button
        type="button"
        onClick={() => switchTo('zh-TW')}
        aria-pressed={current === 'zh-TW'}
        className={seg(current === 'zh-TW')}
      >
        中
      </button>
    </div>
  );
};

export default LanguageSwitcher;
